/**
 * CSV Upload Constants
 * Shared constants for CSV file upload functionality
 */

/**
 * Maximum file size for CSV upload (25MB in bytes)
 */
export const MAX_FILE_SIZE = 25 * 1024 * 1024;

/**
 * Accepted file extensions for CSV upload
 */
export const ACCEPTED_FORMATS = ['.csv', '.xls', '.xlsx'];

/**
 * Accepted MIME types for CSV upload
 */
export const ACCEPTED_MIME_TYPES = [
  'text/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

/**
 * CSV template headers (for download)
 */
export const CSV_HEADERS = [
  'NPI',
  'Provider First Name',
  'Provider Last Name',
  'Last 4 of DEA or License',
  "Provider's Email Address",
];

/**
 * Required header groups (lowercase). Each group must have at least one column present.
 * The DEA column accepts the legacy "Last 4..." or new "Last 1–4..." template header.
 */
export const CSV_HEADER_GROUPS = [
  ['npi'],
  ['provider first name'],
  ['provider last name'],
  [
    'last 1–4 of dea or license',
    'last 1-4 of dea or license',
    'last 4 of dea or license',
  ],
  ["provider's email address"],
];

/** All accepted header names (lowercase), for detecting unknown columns */
export const ALL_VALID_CSV_HEADERS = CSV_HEADER_GROUPS.flat();

/**
 * Default CSV template filename
 */
export const DEFAULT_TEMPLATE_FILENAME = 'CSV Roster Upload Template.csv';

/**
 * Supported file formats display text
 */
export const SUPPORTED_FORMATS_TEXT = 'CSV, XLS, XLSX';

/**
 * Maximum file size display text
 */
export const MAX_FILE_SIZE_TEXT = '25MB';
